import React, { useEffect, useState } from 'react'
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter'
import VerticalTable from '../../components/verticalTable';
import LineChart from '../../components/chartTypes/lineChart';
import { generateDeliquencyLinechart, generatePortfolioSummary } from '../../services/summaryReport';
import { generatePrincipalDPDEwi } from '../../services/delinquencyReports';
import { useTranslation } from 'react-i18next';
import { sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';
import { baseURL } from '../../services';

const TamilNaduEWI = () => {
        const { t } = useTranslation();
    
        
    const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => ({
            periodWithOutDay: ["month"],
            state: ["31"], //tamilnadu
            fromDate: [sixMonthsAgoFormatted],
            toDate: [twoDaysAgoFormatted]
    }));

    const filters = [
        { key: "state", type: "select", label: t("filters.state"), isDisabled: true },
        // { key: "territory", type: "select", label:  t("filters.territory") },
        { key: "cluster", type: "select", label: t("filters.cluster") },
        { key: "branch", type: "select", label: t("filters.branch") },
        { key: "periodWithOutDay", type: "singleSelect", label: t("filters.period") },
        { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate  },
        { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: twoDaysAgoFormatted },
    ];

    const [applyFilter, setApplyFilter] = useState<boolean>(false);
    const [portfolioSummary, setPortfolioSummary] = useState<{ headers: string[]; data: { category: string; values: string[] }[] }>({
        headers: [],
        data: [],
    });
    const [principalDPDEwi, setPrincipalDPDEwi] = useState<{ headers: string[]; data: { category: string; values: string[] }[] }>({
        headers: [],
        data: [],
    });
    const [portfolioMovement, setPortfolioMovement] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [principalDPDEwiLoading, setPrincipalDPDEwiLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    
    const handleFilterChange = (updatedValues: Record<string, string[]>) => {
        setSelectedFilters(updatedValues);
        };
//Api to get tamilnadu portfolio summary data
    const generateTamilNaduPortfolioSummaryApi = async () => {
        setLoading(true);
        try {
          const response = await generatePortfolioSummary(selectedFilters); // Call the API function
          // Transform data for the table
            const apiData = response.data;
            const headers = [" ", ...apiData.map((item: any) => item.period)];
            const transformedData = [
                {
                    category: "# Loans",
                    values: apiData.map((item: any) => item.active_loan_count),
                },
                {
                    category: "PE O/S",
                    values: apiData.map((item: any) => item.tot_princ_os_amt_formatted), // Using formatted value
                },
                {
                    category: "PE O/S per a/c",
                    values: apiData.map((item: any) => item.princ_os_amt_per_account),
                },
            ];

            // Update state with transformed data
            setPortfolioSummary({ headers, data: transformedData });
        } catch (err) {
          setError("Failed to fetch users");
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
//Api to get PE O/S by DPD table data
    const getGenerateTamilNaduPrincipalDPDEwi = async () => {
          setPrincipalDPDEwiLoading(true);
          try {
            const response = await generatePrincipalDPDEwi(selectedFilters); // Call the API function
            const apiData: any[] = response.data; // Ensure it's treated as an array of objects

            // Extract unique bucket names from the first period entry
            const bucketCategories = apiData[0]?.dpd_buckets.map((bucket: { bucket_name?: string; slab_name?: string }) => ({
                category: bucket.bucket_name || bucket.slab_name || "Unknown", // Handle different key names safely
            })) || [];

            // Transform the API response into table format
            const headers: string[] = ["DPD Bucket", ...apiData.map((item: { period: string }) => item.period)];

            const transformedData = bucketCategories.map(({ category }: { category: string }, index: number) => ({
                category,
                values: apiData.map((item: { dpd_buckets: { percentage?: string }[] }) => item.dpd_buckets[index]?.percentage || "0"),
            }));
    
            // Update state with transformed data
            setPrincipalDPDEwi({ headers, data: transformedData });
        
          } catch (err) {
            console.error(err);
          } finally {
            setPrincipalDPDEwiLoading(false);
          }
    };
//Api to get deliquency linechart data
    const generateTamilNaduPortfolioNetMovement= async () => {
        try {
          const response = await generateDeliquencyLinechart(selectedFilters); // Call the API function
          setPortfolioMovement(response.data); // Update state with user data
        } catch (err) {
          setError("Failed to fetch users");
          console.error(err);
        } finally {
        //   setPortfolioMovementLoading(false);
        }
    };
//handle download button Api
    const handleDownloadClick = () => {   
            const link = `${baseURL}generate/portfolio_summary/list_csv_by_state?from_date=${selectedFilters.fromDate ?? ""}&to_date=${selectedFilters.toDate ?? ""}&group_by=${selectedFilters.periodWithOutDay ?? ""}&state_id=${selectedFilters.state ?? ""}&territory_id=${selectedFilters.territory ?? ""}&cluster_id=${selectedFilters.cluster ?? ""}&branch_id=${selectedFilters.branch ?? ""}`;
            window.location.href = link;
          }
//handle cancel click
    const handleCancelClick = () => {
        setSelectedFilters({
            periodWithOutDay: ["month"],
            state: ["31"], //tamilnadu
            fromDate: [sixMonthsAgoFormatted],
            toDate: [twoDaysAgoFormatted]
        })
        setApplyFilter(!applyFilter)
        }

    useEffect(() => {
            generateTamilNaduPortfolioSummaryApi();
            getGenerateTamilNaduPrincipalDPDEwi();
            generateTamilNaduPortfolioNetMovement();
        }, [applyFilter]);


  return (
    <div>
              {/* Page Content */}
              <div className="page-content">
            {/* Dynamic Grey Header */}
            <div className="header">
            {t('portfolioSummaryEWI.tamilNaduEWI.pageTitle')}
            </div>

            <div className="content px-3">
                <MultiSelectCheckboxGroup 
                filters={filters} 
                selectedValues={selectedFilters} 
                onChange={handleFilterChange} 
                isLoading={[loading, principalDPDEwiLoading]}
                buttons={[
                    { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter)},
                    { label: t("buttons.cancel"), onClick: () => handleCancelClick()},
                    { label:  t("buttons.download"), onClick: () => handleDownloadClick()},
                ]}
                />
            </div>
            <div className="p-2 me-3">
                <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('portfolioSummaryEWI.tamilNaduEWI.Tamil Nadu Portfolio Summary')}</h2>
                <VerticalTable headers={portfolioSummary.headers} data={portfolioSummary.data} loading={loading} />
            </div>
            <div className="p-2 me-3">
                <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('portfolioSummaryEWI.tamilNaduEWI.PE O/S by DPD')}</h2>
                <VerticalTable headers={principalDPDEwi.headers} data={principalDPDEwi.data} loading={principalDPDEwiLoading}/>
            </div>
            <div className="mt-1 p-2">
                <LineChart 
                    title={t('portfolioSummaryEWI.tamilNaduEWI.title')}
                    labels={portfolioMovement.map(item => item.period)}
                    dataSets={[
                        { label: "%30+ DPD", data: portfolioMovement.map(item => item.dpd_buckets.find((bucket : any) => bucket.bucket_name === "%30+ DPD")?.percentage || 0), borderColor: "#70e000" },
                        { label: "%60+ DPD", data: portfolioMovement.map(item => item.dpd_buckets.find((bucket : any) => bucket.bucket_name === "%60+ DPD")?.percentage || 0), borderColor: "#003f88" },
                        { label: "%90+ DPD", data: portfolioMovement.map(item => item.dpd_buckets.find((bucket : any) => bucket.bucket_name === "%90")?.percentage || 0), borderColor: "#FF5733" },                  
                    ]}
                    xLabel={t('portfolioSummaryEWI.tamilNaduEWI.xLabel')}
                    yLabel={t('portfolioSummaryEWI.tamilNaduEWI.yLabel')}
                />
            </div>
        </div>
    </div>
  )
}

export default TamilNaduEWI